/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rank: NonNullable<unknown>, total: NonNullable<unknown> }} User_Detail_PlacementInputs */



/**
* | output |
* | --- |
* | "Placement: {rank} of {total} players" |
*
* @param {User_Detail_PlacementInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_placement = /** @type {((inputs: User_Detail_PlacementInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_PlacementInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Classement : ${i?.rank} sur ${i?.total} joueurs`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Clasificación: ${i?.rank} de ${i?.total} jugadores`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Classificação: ${i?.rank} de ${i?.total} jogadores`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Piazzamento: ${i?.rank} su ${i?.total} giocatori`)
	return /** @type {LocalizedString} */ (`Placement: ${i?.rank} of ${i?.total} players`)
});